const faqSearchInput = document.querySelector('.faq__input');
const faqAccordions = document.querySelectorAll('.faq .accordion');
if (faqSearchInput && faqAccordions.length) {
  ['keyup','change'].forEach(evt => 
    faqSearchInput.addEventListener(evt, faqSearch, false)
  );

  function faqSearch(e) {
    faqAccordions.forEach(accorion => {
      if (accorion.textContent.toLowerCase().includes(e.target.value.toLowerCase())) {
        accorion.style.display = "block";
      } else {
        accorion.style.display = "none";
      }
    });
  }
}

const faqCategoryLinks = document.querySelectorAll('[faq-trigger]');
const faqSidebarCategoryLinks = document.querySelectorAll('.faq__sidebar [faq-trigger]');
const faqContentCategoryLinks = document.querySelectorAll('.faq__content [faq-trigger]');
const faqCategories = document.querySelectorAll('.collapsible-content__wrapper');
const backButton = document.querySelector('.faq__sidebar-back');
if (faqCategoryLinks.length && faqCategories.length) {
  if (window.location.hash) {
    const link = document.querySelector('.faq__sidebar a[href="' + window.location.hash + '"]');
    openCateogry(link, false);
  }

  faqCategoryLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      openCateogry(link, true);
    });
  });

  function openCateogry(link, updateState) {
    if (updateState) {
      history.pushState({}, '', '#' + link.dataset.target);
    }
    backButton.style.display = 'flex';
    faqSidebarCategoryLinks.forEach(link => {
      link.classList.remove('faq__sidebar-link--active');
    });
    const sidebarActiveLink = document.querySelector('.faq__sidebar a[href="#' + link.dataset.target + '"]');
    if (sidebarActiveLink) sidebarActiveLink.classList.add('faq__sidebar-link--active');
    faqCategories.forEach(category => {
      if (category.id == link.dataset.target) {
        category.style.display = 'block';
        const faqAccordions = category.querySelectorAll('.accordion');
        faqAccordions.forEach(accorion => {
          accorion.style.display = 'block';
        });
      } else {
        category.style.display = 'none';
      }
    });
    document.querySelector('#top').scrollIntoView();
  }
}